var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81 0.987915H13.191C16.28 0.987915 18 2.74642 18 5.75959V15.9649C18 19.0274 16.28 20.7464 13.191 20.7464H4.81C1.77 20.7464 0 19.0274 0 15.9649V5.75959C0 2.74642 1.77 0.987915 4.81 0.987915ZM5.08 5.59165V5.58177H8.069C8.5 5.58177 8.85 5.92754 8.85 6.35136C8.85 6.78704 8.5 7.13281 8.069 7.13281H5.08C4.649 7.13281 4.3 6.78704 4.3 6.36223C4.3 5.93742 4.649 5.59165 5.08 5.59165ZM5.08 11.5982H12.92C13.35 11.5982 13.7 11.2525 13.7 10.8277C13.7 10.4028 13.35 10.0561 12.92 10.0561H5.08C4.649 10.0561 4.3 10.4028 4.3 10.8277C4.3 11.2525 4.649 11.5982 5.08 11.5982ZM5.08 16.1131H12.92C13.319 16.0735 13.62 15.7367 13.62 15.3425C13.62 14.9374 13.319 14.6015 12.92 14.562H5.08C4.78 14.5324 4.49 14.6707 4.33 14.9275C4.17 15.1745 4.17 15.5005 4.33 15.7574C4.49 16.0044 4.78 16.1526 5.08 16.1131Z",
    fill: "#1A374E",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account_icon.2a0fc3dfcfbd375bc58877ea7b05de20.svg";
export { ForwardRef as ReactComponent };